import { SVGProps } from "react";

export default function Cross(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.21967 0.21967C0.512563 -0.0732233 0.987437 -0.0732233 1.28033 0.21967L20.5799 19.5192L39.8795 0.21967C40.1724 -0.0732233 40.6472 -0.0732233 40.9401 0.21967C41.233 0.512563 41.233 0.987437 40.9401 1.28033L21.6406 20.5799L40.9401 39.8795C41.233 40.1724 41.233 40.6472 40.9401 40.9401C40.6472 41.233 40.1724 41.233 39.8795 40.9401L20.5799 21.6406L1.28033 40.9401C0.987437 41.233 0.512563 41.233 0.21967 40.9401C-0.0732233 40.6472 -0.0732233 40.1724 0.21967 39.8795L19.5192 20.5799L0.21967 1.28033C-0.0732233 0.987437 -0.0732233 0.512563 0.21967 0.21967Z"
        fill="currentColor"
      />
    </svg>
  );
}
